import * as zIndexes from "zIndexes.module.scss";

export const styles = {
  broadcastDialog: {
    position: "fixed",
    top: "calc(50% - 150px)",
    left: "calc(50% - 200px)",
    width: "400px",
    minHeight: "300px",
    height: "auto",
    borderRadius: "15px",
    background: "white",
    border: "1px solid #ccc",
    zIndex: zIndexes.broadcastDialogZIndex,
    boxSizing: "border-box",
    padding: "30px 70px",
    "@media (max-width: 600px)": {
      width: "calc(100vw - 32px)",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
  },
  title: {
    color: "text.primary",
    textAlign: "center",
    padding: "30px 20px",
    lineHeight: "30px",
  },
  text: {
    textAlign: "center",
    color: "text.primary",
    lineHeight: "21px",
  },
  note: {
    marginTop: "10px",
    backgroundColor: "events.blueShade2",
    borderRadius: "5px",
    padding: "10px",
    textAlign: "center",
    color: "text.primary",
  },
  spinner: {
    textAlign: "center",
    position: "relative",
    "& .MuiCircularProgress-root": {
      color: "events.bluePrimary",
    },
  },
  timer: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    left: 0,
    width: "100%",
    textAlign: "center",
  },
  button: {
    borderColor: "#ee4044",
    color: "#ee4044",
    marginTop: "50px",
  },
  stopBroadcastButton: {
    backgroundColor: "red",
  },
};
